<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-select
          id="api_key"
          v-model="leadData.api_key"
          :items="leadProviders"
          item-title="text"
          item-value="value"
          label="API Key"
          outlined
        />
      </v-col>

      <v-col
        cols="12"
        md="2"
        sm="2"
      >
        <v-text-field
          id="ip_address"
          v-model="leadData.ipaddress"
          label="IP Address"
          outlined
        />
      </v-col>

      <v-col
        cols="12"
        md="2"
        sm="2"
      >
        <v-text-field
          id="affiliate_id"
          v-model="leadData.affid"
          label="Affiliate Id"
          outlined
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
        sm="4"
      >
        <v-select
          id="campaign"
          v-model="leadData.campaign"
          :items="campaigns"
          item-title="text"
          item-value="value"
          label="Campaign"
          outlined
        />
      </v-col>

      <v-col
        v-if="isReturnCampaign"
        md="12"
        sm="12"
        offset-md="3"
      >
        <v-col
          cols="12"
          md="6"
          sm="6"
        >
          <v-alert
            v-if="customers.length > 0"
            text
            type="info"
            border="start"
          >
            Please choose the customer you want to return as.
          </v-alert>
          <v-alert
            v-else
            text
            type="error"
            border="start"
          >
            There are no customers to return as. Create a "Purchased" or "Walkup" lead first.
          </v-alert>
        </v-col>

        <v-col
          cols="12"
          md="6"
          sm="6"
        >
          <v-select
            id="customer_guid"
            v-model="leadData.customer_guid"
            :items="customers"
            item-title="text"
            item-value="value"
            label="Customer"
            @change="setReturningCustomer"
          />
        </v-col>
      </v-col>
    </v-row>
    <!--    Loan Information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>
        Loan Information
        <v-row class="justify-end">
          <v-col cols="2">
            <v-checkbox
              id="fund_loan"
              v-model="leadData.fundLoan"
              label="Fund Loan"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row
          v-if="isLineOfCredit"
        >
          <v-col
            cols="12"
          >
            <v-alert
              border="top"
              color="blue lighten-1"
              dark
            >
              Note: If you are trying to create a loan with funds available the
              Request Amount should be 200 greater than Initial amount.
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="request_amount"
              v-model="leadData.requestamount"
              label="Request Amount"
              type="number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="initial_amount"
              v-model="leadData.initialAmount"
              label="Initial Amount"
              type="number"
              outlined
              :disabled="!isLineOfCredit"
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="loan_rate"
              v-model="leadData.loanRate"
              label="Loan Rate"
              type="number"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-text-field
              id="contract_date"
              v-model="leadData.contract_date"
              label="Contract Date"
              type="date"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <v-select
              id="loan_status_id"
              v-model="leadData.loan_status_id"
              :items="loanStatuses"
              item-title="title"
              item-value="id"
              label="Loan Status"
              outlined
              @change="getLoanSubStatus"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="6"
          >
            <v-select
              id="loan_substatus_id"
              v-model="leadData.loan_sub_status_id"
              :items="computedLoanSubStatuses"
              item-title="title"
              item-value="id"
              label="Loan Sub Status"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Loan Information-->
    <!--    Customer Information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>Customer Information</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="first_name"
              v-model="leadData.firstname"
              label="First Name"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="last_name"
              v-model="leadData.lastname"
              label="Last Name"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="home_phone"
              v-model="leadData.homephone"
              label="Home Phone"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="email"
              v-model="leadData.email"
              label="Email"
              outlined
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="address_line_1"
              v-model="leadData.address"
              label="Address Line 1"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="address_line_2"
              v-model="leadData.address2"
              label="Address Line 2"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="city"
              v-model="leadData.city"
              label="City"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-select
              id="us_states"
              v-model="leadData.state"
              label="State"
              :items="usStates"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="zip"
              v-model="leadData.zip"
              label="Zip"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-select
              id="rent_or_own"
              v-model="leadData.rentorown"
              label="Rent or Own?"
              :items="['O', 'R']"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="address_months"
              v-model="leadData.addressmonths"
              label="Address Months"
              type="number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="1"
          >
            <v-text-field
              id="address_years"
              v-model="leadData.addressyears"
              label="Address Years"
              type="number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            lg="3"
            sm="6"
          >
            <v-select
              id="drivers_license_state"
              v-model="leadData.dlstate"
              label="Drivers License State"
              :items="usStates"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            lg="3"
            sm="6"
          >
            <v-text-field
              id="drivers_license_number"
              v-model="leadData.dlnumber"
              label="Drivers License Number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            sm="4"
          >
            <v-select
              id="military"
              v-model="leadData.ismilitary"
              label="Military?"
              :items="['true', 'false']"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            sm="4"
          >
            <v-select
              id="citizen"
              v-model="leadData.iscitizen"
              label="Citizen?"
              :items="['true', 'false']"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            sm="4"
          >
            <v-select
              id="other_offers"
              v-model="leadData.otheroffers"
              label="Other Offers?"
              :items="['true', 'false']"
              outlined
            />
          </v-col>
          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="6"
          >
            <v-text-field
              id="ssn_number"
              v-model="leadData.ssn"
              label="SSN"
              type="number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            lg="2"
            md="4"
            sm="6"
          >
            <v-text-field
              id="date_of_birth"
              v-model="leadData.dob"
              label="Date of Birth"
              type="date"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Customer Information-->
    <!--    Employment information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>Employment Information</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="9"
          >
            <v-row>
              <v-col
                cols="12"
                lg="4"
                sm="6"
              >
                <v-text-field
                  id="employer_name"
                  v-model="leadData.empname"
                  label="Employer Name"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                lg="4"
                sm="4"
              >
                <v-text-field
                  id="employer_phone"
                  v-model="leadData.empphone"
                  label="Employer Phone"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                lg="4"
                sm="2"
              >
                <v-text-field
                  id="emp_phone_ext"
                  v-model="leadData.empphoneext"
                  label="Ext."
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  id="hire_date"
                  v-model="leadData.hiredate"
                  label="Hire Date"
                  type="date"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="employed_months"
                  v-model="leadData.empmonths"
                  label="Employed Months"
                  type="number"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="employed_years"
                  v-model="leadData.empyears"
                  label="Employed Years"
                  type="number"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="net_monthly"
                  v-model="leadData.netmonthly"
                  label="Net Monthly"
                  type="number"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="3"
              >
                <v-text-field
                  id="gross_monthly"
                  v-model="leadData.grossmonthly"
                  label="Gross Monthly"
                  type="number"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                  id="income_type"
                  v-model="leadData.incometype"
                  label="Income Type?"
                  :items="incomeTypes"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                  id="pay_type"
                  v-model="leadData.paytype"
                  label="Pay Type?"
                  :items="payTypes"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
                sm="2"
              >
                <v-select
                  id="pay_frequency"
                  v-model="leadData.payfrequency"
                  label="Pay Frequency"
                  :items="filterPayFrequencies"
                  outlined
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="2"
            offset-md="1"
          >
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  id="last_pay_date"
                  v-model="leadData.lastpaydate"
                  label="Last Pay Date"
                  type="date"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
              >
                <v-text-field
                  id="next_pay_date"
                  v-model="leadData.nextpaydate"
                  label="Next Pay Date"
                  type="date"
                  outlined
                />
              </v-col>

              <v-col
                cols="12"
              >
                <v-text-field
                  id="second_pay_date"
                  v-model="leadData.secondpaydate"
                  label="Second Pay Date"
                  type="date"
                  outlined
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Employment information-->
    <!--    Bank information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>
        Bank Information
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="bank_name"
              v-model="leadData.bankname"
              label="Bank Name"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="routing_number"
              v-model="leadData.routingnumber"
              label="Routing Number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="account_number"
              v-model="leadData.accountnumber"
              label="Account Number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
          >
            <v-select
              id="account_type"
              v-model="leadData.accounttype"
              label="Account Type"
              :items="accountTypes"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
          >
            <v-text-field
              id="bank_months"
              v-model="leadData.bankmonths"
              label="Bank Months"
              type="number"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="1"
          >
            <v-text-field
              id="bank_years"
              v-model="leadData.bankyears"
              label="Bank Years"
              type="number"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Bank information-->
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    leadData: {
      type: Object,
      default() {
        return {};
      },
    },
    leadProviders: {
      type: Array,
      default() {
        return [];
      },
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      },
    },
    usStates: {
      type: Array,
      default() {
        return [];
      },
    },
    customers: {
      type: Array,
      default() {
        return [];
      },
    },
    isReturnCampaign: {
      type: Boolean,
      default: false,
    },
    loanStatuses: {
      type: Array,
      default() {
        return [];
      },
    },
    loanSubStatuses: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      incomeTypes: [
        'E', 'D', 'S', 'U', 'P', 'O',
      ],
      payTypes: [
        'D', 'P', 'C',
      ],
      payFrequencies: [
        'W', 'B', 'S', 'M',
      ],
      accountTypes: [
        'C', 'S',
      ],
      computedLoanSubStatuses: [],
    };
  },

  computed: {
    isLineOfCredit() {
      return this.campaigns.some((campaign) => campaign.value === this.leadData.campaign && campaign.text.includes('lineOfCredit'));
    },
    filterPayFrequencies() {
      if (this.isLineOfCredit) {
        this.updateLeadData({
          payfrequency: 'B',
        });
        return this.payFrequencies.filter((freq) => freq !== 'W');
      }
      this.updateLeadData({
        payfrequency: 'W',
      });
      return this.payFrequencies;
    },
  },

  watch: {
    'leadData.campaign': {
      deep: true,
      handler() {
        if (!this.isLineOfCredit) {
          this.updateLeadData({
            initialAmount: this.leadData.requestamount,
          });
        }
      },
    },
  },

  mounted() {
    this.getLoanSubStatus(this.leadData.loan_status_id);
  },
  methods: {
    ...mapActions('testSuite', ['updateLeadData']),

    setReturningCustomer(val) {
      const customer = this.customers.find((customerN) => customerN.value === val);
      this.updateLeadData({
        return_customer: 1,
        customer_guid: val,
        firstname: (customer) ? customer.firstname : this.leadData.firstname,
        lastname: (customer) ? customer.lastname : this.leadData.lastname,
        email: (customer) ? customer.email : this.leadData.email,
        homephone: (customer) ? customer.homephone : this.leadData.homephone,
      });
    },
    getLoanSubStatus(parentId) {
      this.computedLoanSubStatuses = this.loanSubStatuses.filter((st) => st.parent === parentId);
    },
  },
};
</script>
